import React, { useEffect, useState } from "react";
import { Button, TextField, Typography, Box, Card } from "@mui/material";
import sliderBg from "../../../assets/images/content/slider-bg.png";
import Grid from "@mui/material/Grid2";
import useWindowSize from "../../../hooks/useWindowSize";
import { getFirstValueFromContentArray, getRequiredValueFromContentObject, uploadFile } from "../../../utils/utils";
import BackdropLoader from "../../../components/common/BackdropLoader";
import { patch, get } from "../../../services/apiService";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import UploadIcon from "@mui/icons-material/CloudUpload";
import { useAuth } from "../../../hooks/useAuth";
import i18next from "i18next";



const HomePreview = () => {
  const isArabic = i18next.language === "ar";
  const { currentLang } = useAuth();
  const direction = currentLang === "en" ? "ltr" : "rtl";
  const { width } = useWindowSize();
  // const [imageSize, setImageSize] = useState(null);
  const [headings, setHeadings] = useState({
    image1: "",
    image2: "",
    image3: "",
  });
  const [descriptions, setDescriptions] = useState({
    image1: "",
    image2: "",
    image3: "",
  });

  const [actualContent, setActualContent] = useState([]);
  // States for image, heading, and description for each of the 3 images
  const [previewImages, setPreviewImages] = useState({
    image1: null,
    image2: null,
    image3: null,
  });

  const [activeHeading, setActiveHeading] = useState(headings.image1);
  const [activeDescription, setActiveDescription] = useState(
    descriptions.image1,
  );
  const [activeImage, setActiveImage] = useState("");
  const [uploadedImagesUrl, setUploadedImagesUrl] = useState({
    image1: null,
    image2: null,
    image3: null,
  });

  const [bgImage] = useState(sliderBg);
  const [isLoading, setIsLoading] = useState(false);
  const userId = localStorage.getItem("userId");
  const { id: userSectionId } = useParams();

  const onLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  const handleImageUpload = async (event, imageKey) => {
    const file = event.target.files[0];
    // if (file) {
    // setImageSize(file.size);
    const uploadedUrl = await uploadFile(file, onLoading);
    setActiveImage(uploadedUrl);
    setUploadedImagesUrl((prev) => ({
      ...prev,
      [imageKey]: uploadedUrl,
    }));
    // }
  };

  const handleDescriptionChange = (e, imageKey) => {
    setDescriptions((prev) => ({
      ...prev,
      [imageKey]: e.target.value,
    }));
  };

  const handleHeadingChange = (e, imageKey) => {
    setHeadings((prev) => ({
      ...prev,
      [imageKey]: e.target.value,
    }));
  };

  const fetchContent = async () => {
    const response = await get(
      `users/${userId}/section/${userSectionId}`,
      {},
      onLoading,
    );
    console.log("content response--------->", response?.data?.content);
    const contentResponse = response?.data?.content;
    setActualContent(contentResponse);
    const imagesContent = contentResponse.filter(
      (content) => content.contentType === "img",
    );
    const textContent = contentResponse.filter(
      (content) =>
        content.contentType === "text" || content.contentType === "p",
    );
    const headingContent = contentResponse.filter((content) =>
      content.contentType.includes("h"),
    );
    console.log("images content----------->", imagesContent);
    console.log("Heading content --------------->", headingContent);
    console.log("text content --------------->", textContent);
    if (imagesContent.length > 0) {
      setActiveImage(getFirstValueFromContentArray(imagesContent, currentLang));

      for (let i = 0; i < imagesContent.length; i++) {
        const image = getRequiredValueFromContentObject(
          imagesContent[i],
          currentLang,
        );
        setPreviewImages((prevPreview) => ({
          ...prevPreview,
          [`image${i + 1}`]: image.replace(/\n/g, "").trim(),
        }));

        setUploadedImagesUrl((prevUploadedImage) => ({
          ...prevUploadedImage,
          [`image${i + 1}`]: image.replace(/\n/g, "").trim(),
        }));
      }
      // setPreviewImages({
      //   image1: imagesContent[0]?.content,
      //   image2: imagesContent[1]?.content,
      //   image3: imagesContent[2]?.content,
      // });

      // setUploadedImagesUrl({
      //   image1: imagesContent[0]?.content,
      //   image2: imagesContent[1]?.content,
      //   image3: imagesContent[2]?.content,
      // });
    }
    if (headingContent?.length > 0) {
      setActiveHeading(
        getFirstValueFromContentArray(headingContent, currentLang),
      );
      for (let i = 0; i < headingContent.length; i++) {
        const heading = getRequiredValueFromContentObject(
          headingContent[i],
          currentLang,
        );
        setHeadings((prevHeadings) => ({
          ...prevHeadings,
          [`image${i + 1}`]: heading.replace(/\n/g, "").trim(),
        }));
      }
    }
    if (textContent?.length > 0) {
      setActiveDescription(
        getFirstValueFromContentArray(textContent, currentLang),
      );
      for (let i = 0; i < textContent.length; i++) {
        const description = getRequiredValueFromContentObject(
          textContent[i],
          currentLang,
        );
        setDescriptions((prevDescriptions) => ({
          ...prevDescriptions,
          [`image${i + 1}`]: description.replace(/\n/g, "").trim(),
        }));
      }
    }
  };

  const handleSubmit = async () => {
    //convert the heading, description and images state in this shape
    console.log("uploaded Images url------->", uploadedImagesUrl);
    console.log("current language", currentLang);
    console.log("current language", typeof currentLang);
    if (
      uploadedImagesUrl.image1 &&
      uploadedImagesUrl.image2 &&
      uploadedImagesUrl.image3 &&
      headings.image1 &&
      headings.image2 &&
      headings.image3 &&
      descriptions.image1 &&
      descriptions.image2 &&
      descriptions.image3
    ) {
      console.log("updated headings", headings);
      console.log("updated descriptions", descriptions);
      const updatedContentArray = actualContent.map((contentItem, index) => {
        let updatedTranslations = [...contentItem.translation]; // start with existing translations

        // Check for each type separately and update if needed
        console.log("index", index);
        const realIndex = index % 3;

        const imgValue = uploadedImagesUrl["image" + (realIndex + 1)];
        const headingValue = headings["image" + (realIndex + 1)];
        const descriptionValue = descriptions["image" + (realIndex + 1)];

        if (contentItem.contentType === "img" && imgValue) {
          updatedTranslations.forEach((trans) => {
            if (trans.languageCode === currentLang) {
              trans.languageText = imgValue; // directly modify
            }
          });
        }

        if (contentItem.contentType.includes("h") && headingValue) {
          updatedTranslations.forEach((trans) => {
            if (trans.languageCode === currentLang) {
              trans.languageText = headingValue; // directly modify
            }
          });
          console.log("updated translation", updatedTranslations);
        }

        if (
          (contentItem.contentType === "p" ||
            contentItem.contentType === "text") &&
          descriptionValue
        ) {
          updatedTranslations.forEach((trans) => {
            if (trans.languageCode === currentLang) {
              trans.languageText = descriptionValue; // directly modify
            }
          });
        }

        return {
          ...contentItem,
          translation: updatedTranslations,
        };
      });

      console.log("updated content------>", updatedContentArray);

      const finalObject = { sectionContent: updatedContentArray };

      console.log("Formatted Data:", finalObject);
      const updateContentResponse = await patch(
        `users/${userId}/section/${userSectionId}/content`,
        finalObject,
        {},
        onLoading,
      );
      console.log("update content response--------->", updateContentResponse);
      if (updateContentResponse.status === 200) {
        console.log("need to call api fetch content again-------------->");
        fetchContent();
      }
    } else {
      toast.error(i18next.t("Please Fill all the fields"));
    }
  };

  const handlePreview = (activeHeading, activeDescription, activeImageUrl) => {
    console.log(
      "inside preview handler",
      activeHeading,
      activeDescription,
      activeImageUrl,
    );
    setActiveHeading(activeHeading);
    setActiveDescription(activeDescription);
    setActiveImage(activeImageUrl);
  };
  useEffect(() => {
    fetchContent();
  }, [currentLang]);

  useEffect(() => {
    console.log("headings to be rendered---------->", headings);
    console.log("descriptions to be rendered---------->", descriptions);
    console.log("actual content to be rendered---------->", actualContent);
  }, [headings, descriptions, actualContent]);

  return (
    <Box p={1} dir={direction}>
      <Card
        sx={{ display: "flex", alignItems: "center", p: 2, marginTop: "1.5%" }}
      >
        <Box sx={{ borderRadius: "50%", marginRight: 2 }}>
          <Typography
            sx={{
              fontFamily: "Tajawal-Bold",
              color: "#0A0A0A",
              fontSize: width > 900 ? "26px" : "18px",
              fontWeight: 700,
            }}
          >
            {i18next.t("Home Preview")}
          </Typography>
        </Box>
      </Card>
      {isLoading && <BackdropLoader />}
      <Grid container spacing={2} sx={{ marginTop: "2%" }}>
        {/* Left Side - Page Preview */}
        <Grid item size={{ sm: 12 }} sx={{ width: "100%" }}>
          <Box
            p={3}
            sx={{
              height: "661px",
              width: "100%",
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              border: "1px solid #ccc",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "grey",
            }}
          >
            {/* Text Section */}
            <Grid container spacing={2} sx={{ width: "100%" }}>
              {/* Text Section */}
              <Grid
                item
                size={{ xl: 5, lg: 4, md: 3.5, sm: 12, xs: 12 }}
                sx={{
                  color: "white",
                  display: "flex", // Turn on flexbox
                  flexDirection: "column", // Keep content in column direction
                  alignItems: "center", // Horizontally center the content
                  justifyContent: "center", // Vertically center the content
                  // height: "1000px", // Full height to take up the available space
                  textAlign: "center", // Center the text horizontally inside the Grid
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: width > 900 ? "56px" : "24px",
                  }}
                >
                  {activeHeading}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Tajawal-Regular",
                    marginTop: "1rem",
                    fontSize: width > 900 ? "20px" : "18px",
                  }}
                >
                  {activeDescription}
                </Typography>
                <Button
                  variant="outlined"
                  sx={{ color: "white", marginTop: "5%" }}
                >
                  {i18next.t("Get Started")}
                </Button>
              </Grid>

              {/* Image Section */}
              <Grid
                item
                size={{ xl: 7, lg: 8, md: 8.5, sm: 12, xs: 12 }}
                sx={{
                  display: "flex", // Ensure this is a flex container
                  justifyContent: "flex-end", // Right-align the content (image)
                  alignItems: "center", // Vertically center the image within the Grid item
                }}
              >
                {activeImage?.length > 0 && (
                  <Box
                    sx={{
                      height: "100%", // Ensure the Box takes the full height of Grid
                      width: "100%", // Ensure the Box takes the full width of Grid
                      // Adjust image size based on screen width
                      display: "flex", // Ensure flexbox layout for the container
                      justifyContent: "center", // Center the image horizontally
                      alignItems: "center", // Center the image vertically
                    }}
                  >
                    <img
                      src={activeImage}
                      alt="Preview"
                      style={{
                        width: width > 600 ? "400px" : "280px",
                        height: width > 600 ? "400px" : "280px", // Adjust image size based on screen width
                        // Control the height based on screen width
                        // Ensure the image scales within the Box without distortion
                        borderRadius: "10px",
                      }}
                    />
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Right Side - Image Uploaders */}
        {/* <Grid item size={{ sm: 12 }} sx={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <TextField
              placeholder="Heading"
              variant="outlined"
              fullWidth
              value={heading}
              onChange={(e) => setHeading(e.target.value)}
            />
            <TextField
              placeholder="Description"
              variant="outlined"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              multiline
              rows={2}
            />

            {["image1", "image2", "image3"].map((imageKey) => (
              <Box key={imageKey} width="100%">
                <Button
                  variant="outlined"
                  sx={{
                    width: "100%",
                    justifyContent: "space-between",
                    padding: "1rem",
                    border: "2px dashed #4789C5",
                    color: "#4789C5",
                    "&:hover": { border: "2px solid #4789C5" },
                  }}
                  onClick={() => {
                    if (uploadedImagesUrl[imageKey]) {
                      setPreviewImage(uploadedImagesUrl[imageKey]);
                    }
                  }}
                >
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      document.getElementById(`file-input-${imageKey}`).click();
                    }}
                  >
                    {uploadedImagesUrl[imageKey]?.length > 0
                      ? "Image Uploaded"
                      : "Drag & Drop files or Browse"}
                  </span>
                  <Typography>See Preview</Typography>
                  <input
                    id={`file-input-${imageKey}`}
                    type="file"
                    hidden
                    onChange={(e) => handleImageUpload(e, imageKey)}
                  />
                </Button>
              </Box>
            ))}

            <Box justifyContent="center" textAlign="center" width="100%">
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#3173B1",
                  width: width > 450 ? "10%" : "30%",
                  color: "white",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#3173B1" },
                }}
                onClick={handleSubmit}
              >
                Save
              </Button>
              <Button
                variant="outlined"
                sx={{
                  color: "black",
                  borderColor: "black",
                  marginLeft: "1%",
                  width: width > 450 ? "10%" : "30%",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#f2f2f2" },
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Grid> */}

        <Grid item size={{ xs: 12 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            {/* Heading and Description Inputs for Each Image */}
            {["image1", "image2", "image3"].map((imageKey) => (
              <Box key={imageKey} width="100%">
                <Button
                  key={imageKey}
                  variant="outlined"
                  component="label"
                  sx={{
                    width: "100%",
                    height: "70px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "2px dashed #4789C5",
                    color: "#4789C5",
                    fontSize: "1rem",
                    marginTop: "1.7%",
                    fontFamily: "Tajawal-Regular",
                    "&:hover": { border: "2px solid #4789C5" },
                  }}
                >
                  {uploadedImagesUrl[imageKey]
                    ? i18next.t("Image Uploaded")
                    : i18next.t("Drag & Drop files or Browse")}
                  <UploadIcon
                    sx={{
                      marginLeft: !isArabic && "0.5rem",
                      marginRight: isArabic && "0.5rem",
                      color: "#4789C5",
                    }}
                  />
                  <input
                    type="file"
                    hidden
                    onChange={(e) => handleImageUpload(e, imageKey)}
                  />
                </Button>

                <TextField
                  placeholder={`Heading for ${imageKey}`}
                  variant="outlined"
                  fullWidth
                  sx={{ marginTop: { sm: "3%", xs: "6%" } }}
                  value={headings[imageKey]}
                  onChange={(e) => handleHeadingChange(e, imageKey)}
                />
                <TextField
                  placeholder={`Description for ${imageKey}`}
                  variant="outlined"
                  fullWidth
                  sx={{ marginTop: { sm: "3%", xs: "6%" } }}
                  value={descriptions[imageKey]}
                  onChange={(e) => handleDescriptionChange(e, imageKey)}
                  multiline
                  rows={2}
                />
                <Button
                  onClick={() =>
                    handlePreview(
                      headings[imageKey],
                      descriptions[imageKey],
                      previewImages[imageKey],
                    )
                  }
                >
                  {" "}
                  {i18next.t("Preview")}
                </Button>

                {/* Image Uploader */}
              </Box>
            ))}

            {/* Buttons for Save and Cancel */}
            <Box justifyContent="center" textAlign="center" width="100%">
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#3173B1",
                  color: "white",
                  fontWeight: "bold",
                  width: width > 600 ? "140px" : "100px",
                  "&:hover": { backgroundColor: "#3173B1" },
                }}
                onClick={handleSubmit}
              >
                {i18next.t("Save Changes")}
              </Button>
              <Button
                variant="outlined"
                sx={{
                  color: "black",
                  borderColor: "black",
                  width: width > 600 ? "140px" : "100px",
                  marginLeft: !isArabic && "1%",
                  marginRight: isArabic && "1%",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#f2f2f2" },
                }}
              >
                {i18next.t("Cancel")}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomePreview;
